export const PUT_ACCESS_TOKEN = 'put_access_token';